import { Button } from '@/components/ui/button';
import HeroCarpetImg from '@/assets/images/about/hero-carpet.webp';
import { RulesPopup } from '@/components/rules-popup';
import HeroBackgroundImg from '@/assets/images/about/hero-background.png';
import { useLocation } from 'wouter';
import { HeroNavButtons } from '@/components/hero-nav-buttons';

interface HeroContentProps {
  source?: string;
  onChooseGame?: () => void;
}

function HeroContent({ source, onChooseGame }: HeroContentProps) {
  const isQuizplease = source === 'quizplease';

  return (
    <div className="flex flex-col gap-8">
      <div className="text-center xl:text-left">
        <h1 className="text-3xl sm:text-6xl font-extrabold mb-5">
          {isQuizplease ? (
            <>
              Играйте в Квиз, Плиз! <br /> Везде и сразу
            </>
          ) : (
            <>Интеллектуально-развлекательная платформа викторин от Квиз, плиз!</>
          )}
        </h1>
        <p className="text:xl sm:text-2xl font-medium">
          {isQuizplease ? (
            <>
              Квиз, плиз! Хоум — это домашняя версия игры. Всё, что вы так любите с нами в барах,
              теперь живет в браузере: вопросы, ответы и веселье, с друзьями или в одиночку. Где и
              когда угодно.
            </>
          ) : (
            <>
              Как онлайн-кинотеатр, но для викторин: запускайте в браузере и устраивайте битву умов.
              С близкими или в одиночку — где и когда угодно.
            </>
          )}
        </p>
      </div>
      <div className="flex-col gap-4 sm:gap-[1.875rem] sm:flex-row flex justify-center xl:justify-start z-100">
        <Button
          onClick={onChooseGame}
          variant="default"
          className="py-3 px-4 md:py-4 md:px-6 rounded-[1rem] md:rounded-[1.25rem] "
        >
          <span className="text-base md:text-xl">Выбрать игру</span>
        </Button>
        <RulesPopup />
      </div>
    </div>
  );
}

interface HeroSectionProps {
  source?: string;
  onChooseGame?: () => void;
}
export function HeroSection({ source, onChooseGame }: HeroSectionProps) {
  const [, navigate] = useLocation();

  return (
    <section className="relative h-auto xl:h-[43.75rem] 3xl:h-[48rem]">
      <HeroNavButtons className="xl:mt-0 xl:absolute xl:left-0 xl:top-6 3xl:top-[4rem]" />
      <div className="flex items-center justify-center h-full xl:items-stretch flex-col-reverse xl:flex-row">
        <div className="w-full xl:w-[50%] 3xl:w-[45%] flex justify-center items-center">
          <HeroContent source={source} onChooseGame={onChooseGame} />
        </div>
        <div className="xl:p-6 h-[17rem] md:h-[26.5rem] w-[17rem] md:w-[26.5rem] xl:h-auto  xl:w-[50%] 3xl:w-[55%] flex justify-center items-center">
          <img
            src={HeroCarpetImg}
            alt="Carpet"
            className="max-h-full max-w-full  object-contain object-center"
          />
        </div>
      </div>
      {/* <div className="absolute w-screen top-[1.875rem] xl:top-[7.4rem] left-0 h-[33rem] xl:h-auto ">
        <img src={HeroBackgroundImg} alt="Background" className="w-screen h-full opacity-5 -z-10" />
      </div> */}
    </section>
  );
}
